export default (renderOptions, isFirstRender) => {
  const { query, refine, clear, isSearchStalled, widgetParams } = renderOptions;

  if (isFirstRender) {
    const input = widgetParams.container.querySelector('input');
    input.addEventListener(
      'input',
      (event) => {
        refine(event.target.value);
        widgetParams.onInput();
      },
      false,
    );
    input.addEventListener(
      'focus',
      function () {
        widgetParams.container.classList.add('active');
      },
      false,
    );
    input.addEventListener(
      'keydown',
      function (e) {
        if (e.which === 40) {
          // Arrow down
          e.preventDefault();
          widgetParams.onSelect('down');
        } else if (e.which === 38) {
          // Arrow up
          e.preventDefault();
          widgetParams.onSelect('up');
        } else if (e.which === 27) {
          // Escape
          e.preventDefault();
          widgetParams.onBlur();
        } else if (e.which === 13) {
          // Enter
          e.preventDefault();
          widgetParams.onSubmit();
        }
      },
      false,
    );

    widgetParams.container.querySelector('.js-tindex-clear').addEventListener(
      'click',
      () => {
        clear();
        widgetParams.onClear();
      },
      false,
    );
  }

  widgetParams.container.querySelector('input').value = query;
  widgetParams.container.querySelector('.spinner').hidden = !isSearchStalled;
  widgetParams.container.querySelector('.js-tindex-clear').hidden =
    query === '';
  widgetParams.container.querySelector('.tindex-search__search').hidden =
    query !== '';
  //widgetParams.container.querySelector('.js-tindex-autocomplete').hidden =
  //query === '';
};
